module.exports = __webpack_public_path__ + "img/adf-airforce-sm.d28a7ff.webp";